const required = message => ([field, value]) => {
  return !value.toString().trim() ? message || `${field} is required.` : '';
};

const requiredNumeral = message => ([field, value]) => {
  return isNaN(value) || !value ? message || `${field} is required.` : '';
};

const maxLength = (maxLength, message) => ([field, value]) => {
  return value && value.length > maxLength ? message || `${field} is .` : '';
};

const requiredList = message => ([field, value]) => {
  return !value || value.length === 0 ? message || `${field} is required.` : '';
};

const allOf = validations => formData => {
  let errorMessage = '';
  validations.some(validation => {
    errorMessage = validation(formData);
    return !!errorMessage;
  });
  return errorMessage;
};

export function validation() {
  return {
    offerDetails: allOf([
      required('Giving an offer is necessary.'),
      maxLength(800, 'Can it be 800 characters or less, please?'),
    ]),
    name: required('Your name is necessary.'),
    phone: required('We need your phone number to connect you for this offer.'),
  };
}
